import { EditVisual } from '../../../../ui/features/visuals/components/EditVisual';
import { NewVisual } from '../../../../ui/features/visuals/components/NewVisual';
import { VisualList } from '../../../../ui/features/visuals/components/VisualList';
import React from 'react';
import { Route, Routes } from 'react-router';
export const VisualPanel = ({ hideHeader }) => {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: '', element: React.createElement(VisualList, { hideHeader: hideHeader }) }),
        React.createElement(Route, { path: '/new/*', element: React.createElement(NewVisual, null) }),
        React.createElement(Route, { path: '/:visualId/*', element: React.createElement(EditVisual, null) })));
};
